var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResourcesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 0C7.61097 0 0 7.61097 0 17C0 26.389 7.61097 34 17 34C26.389 34 34 26.389 34 17C34 7.61097 26.389 0 17 0ZM17 32.6403C8.37628 32.6403 1.35969 25.625 1.35969 17C1.35969 8.375 8.375 1.35969 17 1.35969C25.625 1.35969 32.6403 8.375 32.6403 17C32.6403 25.6237 25.625 32.6403 17 32.6403Z",
    fill: "#FF5E4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9421 8.08984C13.4906 8.08984 11.5633 10.2225 11.5391 13.6026H13.0391C12.9919 11.1511 14.2763 9.3526 16.872 9.3526C18.7278 9.3526 20.275 10.6613 20.275 12.5656C20.275 13.8029 19.6079 14.8029 18.7278 15.6358C16.9192 17.3143 16.4128 18.1039 16.321 20.4036H17.8401C17.9294 18.3182 17.8835 18.3603 19.7036 16.5401C20.9179 15.3972 21.7738 14.2544 21.7738 12.4929C21.7738 9.7327 19.5837 8.08984 16.9434 8.08984H16.9421Z",
    fill: "#FF5E4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9993 23.1211C16.2493 23.1211 15.6396 23.7295 15.6396 24.4808C15.6396 25.2321 16.2493 25.8405 16.9993 25.8405C17.7493 25.8405 18.359 25.2321 18.359 24.4808C18.359 23.7308 17.7506 23.1211 16.9993 23.1211Z",
    fill: "#FF5E4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourcesIcon);
export default __webpack_public_path__ + "static/media/resourcesIcon.11b22ebfc9179d7696234c30c5888add.svg";
export { ForwardRef as ReactComponent };